/* eslint-disable camelcase */
import { useState } from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';

import styled from 'styled-components';
import { tint } from 'polished';

// import { Icon } from 'react-icons-kit';
// import { ic_add } from 'react-icons-kit/md/ic_add';
// import { ic_sentiment_very_satisfied } from 'react-icons-kit/md/ic_sentiment_very_satisfied';
// import { star } from 'react-icons-kit/fa/star';
// import { ic_linear_scale } from 'react-icons-kit/md/ic_linear_scale';
// // import { thLarge } from 'react-icons-kit/fa/thLarge';
// import { ic_looks_one } from 'react-icons-kit/md/ic_looks_one';
// import { ic_face } from 'react-icons-kit/md/ic_face';
// import { ic_filter_none } from 'react-icons-kit/md/ic_filter_none';
// import { ic_video_call } from 'react-icons-kit/md/ic_video_call';
// import { ic_picture_in_picture } from 'react-icons-kit/md/ic_picture_in_picture';

import TemplateDetailsModal from '@/components/Modal/TemplateDetails';
import { getNewTemplate } from '@/utils/poll-templates';
import { StyledTemplateGrid } from './styled';

const StyledOption = styled.div`
  height: 100%;
  width: 100%;
  background-color: var(--white-hover);
  ${'' /* border-radius: 1rem; */}
  display: grid;
  grid-template-rows: 250px auto;
  grid-gap: 0.25rem;
  .btn-image {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .img-wrapper {
    width: 250px;
    height: 185px;
    position: relative;
    img {
      object-fit: cover;
    }
  }
  .option-footer {
    width: 100%;
    align-items: flex-start;
    display: flex;
    justify-content: center;
    text-align: center;
    font-weight: 600;
    font-size: 0.875rem;
    .block {
      display: block;
    }
  }
  .template-info {
    width: 100%;
    text-align: center;
    padding: 0.5rem 1rem;
    padding-bottom: 1rem;
    .template-title {
      font-weight: 600;
      font-size: 1rem;
      ${'' /* padding-bottom: 0.25rem; */}
    }
    .template-description {
      color: var(--muted-strong);
      font-size: 0.875rem;
      font-weight: 400;
    }
  }
`;

const StyledOptionGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  grid-gap: 1.5rem;
  padding-top: 1rem;
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.sm}) {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.xs}) {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }
`;

const StyledOptionButton = styled.button`
  ${'' /* width: 100%;
  height: 100%; */}
  ${'' /* margin: 0.5rem; */}
  padding: 0;
  background-color: var(--white);
  border: none;
  color: var(--muted-strong);
  display: grid;
  ${'' /* grid-template-rows: auto 3.5rem; */}
  align-items: center;
  ${'' /* border-radius: 1rem; */}
  border-radius: 0;
  border: 1px solid var(--muted-strong);
  &.blank-project {
    border: 2px var(--muted-strong);
    border-style: dashed;
  }
  &.white {
    color: var(--white);
    border-color: var(--white);
    background-color: var(--white);
    &:hover {
      background-color: var(--white);
    }
  }
  &.red {
    color: var(--red);
    border-color: var(--red);
    background-color: ${({ theme }) => tint(0.8, theme.colors.red)};
    &:hover {
      background-color: ${({ theme }) => tint(0.875, theme.colors.red)};
    }
  }
  &.blue {
    color: var(--blue);
    border-color: var(--blue);
    background-color: ${({ theme }) => tint(0.8, theme.colors.blue)};
    &:hover {
      background-color: ${({ theme }) => tint(0.875, theme.colors.blue)};
    }
  }
  &.green {
    color: var(--green);
    border-color: var(--green);
    background-color: ${({ theme }) => tint(0.8, theme.colors.green)};
    &:hover {
      background-color: ${({ theme }) => tint(0.875, theme.colors.green)};
    }
  }
  &.yellow {
    color: var(--yellow);
    border-color: var(--yellow);
    background-color: ${({ theme }) => tint(0.8, theme.colors.yellow)};
    &:hover {
      background-color: ${({ theme }) => tint(0.875, theme.colors.yellow)};
    }
  }
  &.orange {
    color: var(--orange);
    border-color: var(--orange);
    background-color: ${({ theme }) => tint(0.8, theme.colors.orange)};
    &:hover {
      background-color: ${({ theme }) => tint(0.875, theme.colors.orange)};
    }
  }
  &:hover {
    background-color: var(--white-hover);
  }
  &:focus {
    outline: none;
  }
`;

const TEMPLATE_LIST = [
  {
    template: 'blank',
    category: ['Personal', 'Office'],
    title: 'Blank Project',
    description: '',
    src: '/static/images/templates/blank-project.png'
  },
  {
    template: 'likert',
    category: ['Personal'],
    title: 'Likert Example',
    description: '',
    src: '/static/images/templates/likert-simple.png'
  },
  {
    template: 'nps',
    category: ['Personal', 'Marketing'],
    title: 'NPS Example',
    description: '',
    src: '/static/images/templates/nps-example.png'
  },
  {
    template: 'rating',
    category: ['Marketing', 'Office'],
    title: 'Rating Example',
    description: '',
    src: '/static/images/templates/rating-example.png'
  },
  {
    template: 'sentiment',
    category: ['Personal', 'Marketing', 'HR', 'Office'],
    title: 'Sentiment Example',
    description: '',
    src: '/static/images/templates/sentiment-example.png'
  },
  {
    template: 'multi-page',
    category: ['Personal', 'Office'],
    title: 'Multiple Page Example',
    description: (
      <span>
        Basic multiple page example with <em>rating</em> and <em>sentiment</em> questions.
      </span>
    ),
    src: '/static/images/templates/multipage-example.png'
  },
  {
    template: 'social-eat-poll',
    category: ['Social'],
    title: 'What shall we eat today?',
    description: (
      <span>
        Shall we go Pizza, or veggie? or maybe a <em>veggie pizza</em>?
      </span>
    ),
    src: '/static/images/templates/social-eat.png'
  },
  {
    template: 'social-watch-poll',
    category: ['Social'],
    title: 'What should we watch tonight?',
    description: <span>I mean, assuming you do not fall asleep...</span>,
    src: '/static/images/templates/social-watch.png'
  },
  {
    template: 'videoconference-feedback',
    category: ['HR', 'Office'],
    title: 'Videoconference Feedback',
    description: 'Simple base feedback for videoconference context.',
    src: '/static/images/templates/videoconference-feedback.png'
  },
  {
    template: 'post-webinar-survey',
    category: ['Marketing', 'HR', 'Office'],
    title: 'Post-Webinar Micro-survey',
    description:
      'Post-Webinar micro-survey example with multiple question types, designed with webinar context in mind.',
    src: '/static/images/templates/post-webinar-survey.png'
  },
  {
    template: 'satisfaction-survey',
    category: ['Marketing', 'HR'],
    title: 'Satisfaction Micro-survey',
    description: (
      <span>
        Basic satisfaction micro-survey example with multiple question types (<em>checkbox</em>,{' '}
        <em>dropdown</em>, <em>buttons</em>, and others).
      </span>
    ),
    src: '/static/images/templates/satisfaction-survey.png'
  }
  // {
  //   template: 'matrix-example',
  //   category: ['Marketing', 'HR'],
  //   title: 'Matrix template example rendering',
  //   description: (
  //     <span>
  //       Basic satisfaction micro-survey example with multiple question types (<em>checkbox</em>,{' '}
  //       <em>dropdown</em>, <em>buttons</em>, and others).
  //     </span>
  //   ),
  //   src: '/static/images/templates/satisfaction-survey.png'
  // }
];

const TemplateGrid = () => {
  const router = useRouter();
  const [category, setCategory] = useState('');
  const [templates, setTemplates] = useState(TEMPLATE_LIST);
  const [modalOpened, setModalOpened] = useState(false);
  const [templateModel, setTemplateModel] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [templateTitle, setTemplateTitle] = useState('');

  const handleFilter = async filter => {
    let filteredTemplates = [];
    switch (filter) {
      case '':
        filteredTemplates = TEMPLATE_LIST;
        break;
      default:
        filteredTemplates = TEMPLATE_LIST.filter(template => template.category.includes(filter));
        break;
    }
    await setTemplates(filteredTemplates);
    await setCategory(filter);
  };

  const handleSelectTemplate = () => {
    // console.log('use this template');
    // console.log({ selectedTemplate });
    // push to dashboard
    router.push(`/create?template=${selectedTemplate}`);
  };

  const handleTemplateClick = async (template, title = '') => {
    // console.log(template);
    const model = getNewTemplate(template);
    await setSelectedTemplate(template);
    await setTemplateModel(model);
    await setTemplateTitle(title);
    await setModalOpened(true);
  };

  // console.log({ templateModel });

  return (
    <StyledTemplateGrid>
      <TemplateDetailsModal
        isOpen={modalOpened}
        toggleModal={() => setModalOpened(!modalOpened)}
        poll={{
          id: 'template-model',
          model: templateModel,
          title: templateTitle
        }}
        onSelectTemplate={handleSelectTemplate}
        // modalHeight="100vh"
        // modalWidth="100vw"
      />

      <div className="grid-filter">
        <button
          type="button"
          className="all-filter"
          data-active={category === ''}
          onClick={() => handleFilter('')}
        >
          All
        </button>
        <div className="divider" />
        <div className="categories">
          <button
            type="button"
            data-active={category === 'Personal'}
            onClick={() => handleFilter('Personal')}
          >
            Personal
          </button>
          <button
            type="button"
            data-active={category === 'Social'}
            onClick={() => handleFilter('Social')}
          >
            Social
          </button>
          <button
            type="button"
            data-active={category === 'Marketing'}
            onClick={() => handleFilter('Marketing')}
          >
            Marketing
          </button>
          <button type="button" data-active={category === 'HR'} onClick={() => handleFilter('HR')}>
            HR
          </button>
          <button
            type="button"
            data-active={category === 'Office'}
            onClick={() => handleFilter('Office')}
          >
            Office
          </button>
        </div>
      </div>
      <StyledOptionGrid>
        {templates.map(single => {
          const { template, title, description, src } = single;
          return (
            <StyledOption key={template}>
              <StyledOptionButton
                // className="blank-project"
                className="white"
                type="button"
                onClick={() => handleTemplateClick(template, title)}
              >
                <div className="btn-image">
                  <div className="img-wrapper">
                    <Image src={src} alt={`pollme template ${title}`} layout="fill" />
                  </div>
                </div>
              </StyledOptionButton>
              <div className="template-info">
                <div className="template-title">{title}</div>
                <div className="template-description">
                  {typeof description === 'function' ? description() : description}
                </div>
              </div>
            </StyledOption>
          );
        })}
      </StyledOptionGrid>
    </StyledTemplateGrid>
  );
};
export default TemplateGrid;
